export default "__VITE_ASSET__CfcUL5gs__"